import ColorSelector from "./ColorSelector-view";

export default ColorSelector;